module.exports = __webpack_public_path__ + "img/insurita-logo-light.10310e24.svg";